<div class="container-fluid">
  <div class="row mb-2 d-none d-md-block">
    <div class="col-md-12">
      <nav aria-label="breadcrumb" class="d-none d-md-block">
        <ol class="breadcrumb mb-0">
            <li class="breadcrumb-item hcm-breadcrumb-text"><a routerLink="/home">{{
              'stepper.home' | translate }}</a></li>
           <li class="breadcrumb-item active hcm-breadcrumb-text" aria-current="page">{{
            'stepper.create_new_hot_call' | translate }}</li>
          <!-- <li *ngIf="currentSection === 3" class="breadcrumb-item active custom-Roboto custom-weight-500 custom-font-12" aria-current="page">{{ 'stepper.hot_call_management' | translate }}</li> -->
        </ol>
      </nav>
    </div>
  </div>
  <app-create-hot-call-form [currentSection]="currentSection"></app-create-hot-call-form>
</div>